export  default {
    devices(state) {
        return state.devices;
    },
    getContainerDevices(state, payload) {
        return state.containerDevices;
    },
    hasDevices(state) {
        return state.devices && state.devices.length > 0;
    },
    getActiveDevices(state) {
        var active=[]
        var deviceMaster = state.activeDevices
        for (let i = 0; i < deviceMaster.length; i++) {
            // console.log(deviceMaster[i])
            
            const device = {
                surface: deviceMaster[i].containerName,
                alias: deviceMaster[i].alias,
                downholeLSD:deviceMaster[i]['downhole lsd'],
                imei: deviceMaster[i].imei,
                manufacturer: deviceMaster[i].manufacturer,
                containerType: deviceMaster[i].containerType,
                operator: deviceMaster[i].operator,
                area: deviceMaster[i].area,
                office: deviceMaster[i].office,
                district: deviceMaster[i].district,
                product: deviceMaster[i].product,
                satellite: deviceMaster[i].satellite,
                latitude: deviceMaster[i].latitude,
                longitude: deviceMaster[i].longitude,
                contractName: deviceMaster[i].contractName,
                contractDate: deviceMaster[i].contractDate,
                installDate: deviceMaster[i].installDate,
            };
            // console.log(device)
            active.push(device);

        }
        return active;
    },
};